export var translationCss = {
  root: "st-root-modern",
  container: "st-container-modern",
  header: "st-title st-container-modern__title",
  body: "st-body",
  bodyEmpty: "st-body st-body--empty",
  footer: "st-footer st-body__footer st-clearfix",
  title: "",
  description: "",
  logo: "st-logo",
  logoImage: "st-logo__image",
  headerText: "st-header__text",
  navigationButton: "",
  bodyNavigationButton: "st-navigation-btn",
  completedPage: "st-completedpage",
  navigation: {
    complete: "st-btn st-footer__complete-btn",
    prev: "st-btn st-footer__prev-btn",
    next: "st-btn st-footer__next-btn",
    start: "st-btn st-footer__start-btn",
    preview: "st-btn st-footer__preview-btn",
    edit: "st-btn st-footer__edit-btn"
  },
  panel: {
    title: "st-title st-panel__title",
    titleExpandable: "st-panel__title--expandable",
    titleOnExpand: "st-panel__title--expanded",
    titleOnError: "st-panel__title--error",
    description: "st-description st-panel__description",
    container: "st-element st-panel st-row__panel",
    content: "st-panel__content",
    icon: "st-panel__icon",
    iconExpanded: "st-panel__icon--expanded",
    footer: "st-panel__footer",
    requiredText: "st-panel__required-text"
  },
  paneldynamic: {
    root: "st-paneldynamic",
    navigation: "st-paneldynamic__navigation",
    title: "st-title st-question__title",
    button: "st-btn",
    buttonRemove: "st-paneldynamic__remove-btn",
    buttonAdd: "st-paneldynamic__add-btn",
    progressTop: "st-paneldynamic__progress st-paneldynamic__progress--top",
    progressBottom:
        "st-paneldynamic__progress st-paneldynamic__progress--bottom",
    buttonPrev: "st-paneldynamic__prev-btn",
    buttonNext: "st-paneldynamic__next-btn",
    progressContainer: "st-paneldynamic__progress-container",
    progress: "st-progress",
    progressBar: "st-progress__bar",
    progressText: "st-paneldynamic__progress-text",
    separator: "st-paneldynamic__separator",
    panelWrapper: "st-paneldynamic__panel-wrapper",
    panelWrapperInRow: "st-paneldynamic__panel-wrapper--in-row"
  },
  progress: "st-progress st-body__progress",
  progressBar: "st-progress__bar",
  progressText: "st-progress__text",
  progressTextInBar: "st-hidden",
  page: {
    root: "st-page st-body__page",
    title: "st-title st-page__title",
    description: "st-description st-page__description"
  },
  pageTitle: "st-title st-page__title",
  pageDescription: "st-description st-page__description",
  row: "st-row st-clearfix",
  question: {
    mainRoot: "st-element st-question st-row__question",
    flowRoot: "st-element st-question st-row__question st-row__question--flow",
    asCell: "st-table__cell",
    header: "st-question__header",
    headerLeft: "st-question__header--location--left",
    headerTop: "st-question__header--location--top",
    headerBottom: "st-question__header--location--bottom",
    content: "st-question__content",
    contentLeft: "st-question__content--left",
    titleLeftRoot: "",
    titleOnAnswer: "st-question__title--answer",
    titleOnError: "st-question__title--error",
    title: "st-title st-question__title",
    requiredText: "st-question__required-text",
    number: "st-question__num",
    description: "st-description st-question__description",
    descriptionUnderInput: "st-description st-question__description",
    comment: "st-comment",
    required: "st-question--required",
    titleRequired: "st-question__title--required",
    indent: 20,
    footer: "st-question__footer",
    formGroup: "st-question__form-group",
    hasError: "",
    disabled: "st-question--disabled"
  },
  image: { root: "st-image", image: "sv_image_image" },
  error: {
    root: "st-question__erbox",
    icon: "",
    item: "",
    locationTop: "st-question__erbox--location--top",
    locationBottom: "st-question__erbox--location--bottom"
  },
  checkbox: {
    root: "st-selectbase",
    item: "st-item st-checkbox st-selectbase__item",
    itemSelectAll: "st-checkbox--selectall",
    itemNone: "st-checkbox--none",
    itemDisabled: "st-item--disabled st-checkbox--disabled",
    itemChecked: "st-item--checked st-checkbox--checked",
    itemHover: "st-item--allowhover st-checkbox--allowhover",
    itemInline: "st-selectbase__item--inline",
    label: "st-selectbase__label",
    labelChecked: "",
    itemControl: "st-visuallyhidden st-item__control st-checkbox__control",
    itemDecorator: "st-item__svg st-checkbox__svg",
    controlLabel: "st-item__control-label",
    materialDecorator: "st-item__decorator st-checkbox__decorator",
    other: "st-comment st-question__other",
    column: "st-selectbase__column"
  },
  radiogroup: {
    root: "st-selectbase",
    item: "st-item st-radio st-selectbase__item",
    itemInline: "st-selectbase__item--inline",
    label: "st-selectbase__label",
    labelChecked: "",
    itemDisabled: "st-item--disabled st-radio--disabled",
    itemChecked: "st-item--checked st-radio--checked",
    itemHover: "st-item--allowhover st-radio--allowhover",
    itemControl: "st-visuallyhidden st-item__control st-radio__control",
    itemDecorator: "st-item__svg st-radio__svg",
    controlLabel: "st-item__control-label",
    materialDecorator: "st-item__decorator st-radio__decorator",
    other: "st-comment st-question__other",
    clearButton: "st-btn st-selectbase__clear-btn",
    column: "st-selectbase__column"
  },
  boolean: {
    mainRoot: "st-question st-row__question st-question--boolean",
    root: "",
    item: "st-boolean",
    control: "st-boolean__control st-visuallyhidden",
    itemChecked: "st-boolean--checked",
    itemIndeterminate: "st-boolean--indeterminate",
    itemDisabled: "st-boolean--disabled",
    label: "st-boolean__label",
    switch: "st-boolean__switch",
    disabledLabel: "st-checkbox__label--disabled",
    itemDecorator: "st-checkbox__hidden",
    materialDecorator: "st-checkbox__rectangle",
    sliderText: "",
    slider: "st-boolean__thumb"
  },
  text: {
    root: "st-input st-text",
    small: "st-row__question--small",
    controlDisabled: "st-input--disabled",
    onError: "st-input--error"
  },
  multipletext: {
    root: "st-multipletext",
    item: "st-multipletext__item",
    itemTitle: "st-multipletext__item-title",
    row: "st-multipletext__row",
    cell: "st-multipletext__cell"
  },
  dropdown: {
    root: "st-selectbase",
    small: "st-row__question--small",
    control: "st-input st-dropdown",
    other: "st-comment st-question__other",
    onError: "st-input--error",
    label: "st-selectbase__label",
    item: "st-item st-radio st-selectbase__item",
    itemDisabled: "st-item--disabled st-radio--disabled",
    itemChecked: "st-item--checked st-radio--checked",
    itemHover: "st-item--allowhover st-radio--allowhover",
    itemControl: "st-visuallyhidden st-item__control st-radio__control",
    itemDecorator: "st-item__svg st-radio__svg",
    controlDisabled: "st-input--disabled",
    controlLabel: "st-item__control-label",
    materialDecorator: "st-item__decorator st-radio__decorator"
  },
  imagepicker: {
    root: "st-imagepicker",
    item: "st-imagepicker__item",
    itemInline: "st-imagepicker__item--inline",
    itemChecked: "st-imagepicker__item--checked",
    itemDisabled: "st-imagepicker__item--disabled",
    itemHover: "st-imagepicker__item--allowhover",
    label: "st-imagepicker__label",
    itemControl: "st-imagepicker__control",
    image: "st-imagepicker__image",
    itemText: "st-imagepicker__text",
    clearButton: "st-btn",
    other: "st-comment st-question__other"
  },
  matrix: {
    mainRoot: "st-question st-row__question st-scrollable",
    tableWrapper: "st-matrix",
    root: "st-table",
    noHeader: "st-table--no-header",
    rowError: "st-matrix__row--error",
    cell: "st-table__cell st-matrix__cell",
    headerCell: "st-table__cell st-table__cell--header",
    rowTextCell: "st-table__cell st-table__cell--row-text",
    label: "st-item st-radio st-matrix__label",
    itemValue: "st-visuallyhidden st-item__control st-radio__control",
    itemChecked: "st-radio--checked",
    itemDisabled: "st-item--disabled st-radio--disabled",
    itemHover: "st-radio--allowhover",
    materialDecorator: "st-item__decorator st-radio__decorator",
    itemDecorator: "st-item__svg st-radio__svg",
    cellText: "st-matrix__text",
    cellTextSelected: "st-matrix__text--checked",
    cellTextDisabled: "st-matrix__text--disabled"
  },
  matrixdropdown: {
    mainRoot: "st-question st-row__question st-scrollable",
    root: "st-table",
    noHeader: "st-table--no-header",
    cell: "st-table__cell",
    headerCell: "st-table__cell st-table__cell--header",
    rowTextCell: "st-table__cell st-table__cell--row-text"
  },
  matrixdynamic: {
    mainRoot: "st-question st-row__question st-scrollable",
    root: "st-table st-matrixdynamic",
    noHeader: "st-table--no-header",
    cell: "st-table__cell",
    headerCell: "st-table__cell st-table__cell--header",
    rowTextCell: "st-table__cell st-table__cell--row-text",
    button: "st-btn",
    detailRow: "st-table__row st-table__row--detail",
    detailButton: "st-table__cell--detail-button",
    detailButtonExpanded: "st-table__cell--detail-button--expanded",
    detailIcon: "st-detail-panel__icon",
    detailIconExpanded: "st-detail-panel__icon--expanded",
    detailPanelCell: "st-table__cell--detail-panel",
    actionsCell: "st-table__cell st-table__cell--actions",
    buttonAdd: "st-matrixdynamic__add-btn",
    buttonRemove: "st-matrixdynamic__remove-btn",
    iconAdd: "",
    iconRemove: ""
  },
  rating: {
    root: "st-rating",
    item: "st-rating__item",
    itemHover: "st-rating__item--allowhover",
    selected: "st-rating__item--selected",
    minText: "st-rating__item-text st-rating__min-text",
    itemText: "st-rating__item-text",
    maxText: "st-rating__item-text st-rating__max-text",
    itemDisabled: "st-rating__item--disabled"
  },
  comment: {
    root: "st-comment",
    small: "st-row__question--small"
  },
  expression: "",
  file: {
    root: "st-file",
    other: "st-comment st-question__other",
    placeholderInput: "st-visuallyhidden",
    preview: "st-file__preview",
    fileSign: "st-hidden",
    fileSignBottom: "st-file__sign",
    fileDecorator: "st-file__decorator",
    fileInput: "st-visuallyhidden",
    noFileChosen: "st-description st-file__no-file-chosen",
    chooseFile: "st-btn st-file__choose-btn",
    disabled: "st-file__choose-btn--disabled",
    removeButton: "st-hidden",
    removeButtonBottom: "st-btn st-file__clean-btn",
    removeFile: "st-hidden",
    removeFileSvg: "st-file__remove-svg",
    wrapper: "st-file__wrapper"
  },
  signaturepad: {
    root: "st-signaturepad sjs_sp_container",
    small: "st-row__question--small",
    controls: "sjs_sp_controls",
    placeholder: "sjs_sp_placeholder",
    clearButton: "sjs_sp_clear"
  },
  saveData: {
    root: "",
    saving: "",
    error: "",
    success: "",
    saveAgainButton: ""
  },
  window: {
    root: "sv_window",
    body: "sv_window_content",
    header: {
      root: "sv_window_title",
      title: "",
      button: "",
      buttonExpanded: "",
      buttonCollapsed: ""
    }
  }
};
